<template>
  <v-form id="forgot-password-form" @submit.prevent="forgotPassword" class="login px-5 py-3">
    <div :class="{'show-errors': $v.email.$error }">
      <div class="reset-password-info" v-html="$t('reset_password_info')"></div>
      <v-text-field
        prepend-inner-icon="mdi-account"
        id="email"
        :error-messages="emailErrors"
        v-model="email"
        :placeholder="$t('email')"
        solo />
    </div>
    <v-btn type="submit" class="w-100 mx-auto my-2">
      <v-icon>mdi-login</v-icon>
      {{ $t('reset_password') }}
    </v-btn>
    <div v-if="sentForgotPassword" class="reset-password-info py-1 mt-1">
      {{ $t('email_sent_to_above_address') }}
    </div>
    <br>
    <v-btn text class="d-block mx-auto" @click="returnToLogin">
      {{ $t('return_to_login') }}
    </v-btn>
  </v-form>
</template>

<script>
import UrlHelper from '@/util/Url'
import ValidationMixin from '@/components/mixins/ValidationMixin'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ForgotPassword',
  mixins: [ValidationMixin],
  data () {
    return {
      url: `${UrlHelper.getApiUrl()}/auth/forgot-password`,
      email: null,
      // Whether we are currently sending a password reset request
      sendingForgotPassword: false,
      // Whether a reset password has been performed.
      sentForgotPassword: false
    }
  },
  validations: {
    email: {
      required
    }
  },
  methods: {
    returnToLogin () {
      this.$emit('return-to-login')
    },
    forgotPassword () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return false
      }

      this.sentForgotPassword = false
      this.sendingForgotPassword = true
      const formData = new FormData()
      formData.append('username', this.email)

      this.$httpAdapter({
        url: this.url,
        method: 'POST',
        data: formData
      }).finally(() => {
        this.sendingForgotPassword = false
        this.sentForgotPassword = true
      })
    },
    reloadPage () {
      window.location.reload()
    }
  },
  computed: {
    emailErrors () {
      return this.validationErrors([{
        prop: this.$v.email,
        rule: 'required',
        message: this.$t('required')
      }])
    }
  }
}
</script>

<style scoped lang="scss">

.reset-password-info {
  font-size: .85em;
  margin-bottom: 4px;
}
</style>
